import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import Review from '../review';
import { reviewsType } from '../types';
import { jsx as _jsx } from "react/jsx-runtime";

const ReviewList = _ref => {
  let {
    reviews,
    color,
    centreTitle
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    role: "list",
    "aria-label": "List of reviews",
    "data-id": "review-list_index_ReviewList_div",
    children: reviews.map((review, i) => /*#__PURE__*/_jsx(Review, _objectSpread(_objectSpread({
      color: color,
      centreTitle: centreTitle
    }, review), {}, {
      "data-id": "review-list_index_ReviewList_Review"
    }), i))
  });
};

export default ReviewList;